import { AnyObject, API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = { token: string; queryString?: string; skipAutoJoin?: boolean };

const [useLoginWithGoogle, loginWithGoogle] = createAsyncAction(
  "auth/loginWithGoogle",
  async (args: Args) => {
    const endpoint = ["auth/google/", args.queryString?.replace(/^\?/, "")]
      .filter(Boolean)
      .join("?");
    const res = await API.call<{
      user: number;
      intercomId?: string;
      notifications?: AnyObject[];
    }>({
      endpoint,
      method: "POST",
      data: {
        token: args.token,
        skip_auto_join: args.skipAutoJoin,
      },
    });
    return { ...res, result: res.result.user };
  }
);
export default useLoginWithGoogle;
export { loginWithGoogle };
